import { render, staticRenderFns } from "./LookAnswerDetail.vue?vue&type=template&id=5b5b5632&scoped=true&"
import script from "./LookAnswerDetail.vue?vue&type=script&lang=js&"
export * from "./LookAnswerDetail.vue?vue&type=script&lang=js&"
import style0 from "./LookAnswerDetail.vue?vue&type=style&index=0&id=5b5b5632&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b5b5632",
  null
  
)

export default component.exports